module.exports = __webpack_public_path__ + "static/media/PlanInactive.b41f1cb3.png";